import React, { Component } from 'react';
import Popup from './Popup.jsx';
import { DynamicTable } from "dynamic-table-module";
import { SectionsTree } from "sections-tree-module";

class ElementSelector extends Component {
  constructor(props) {
    super(props);
    this.state={
      show_popup:false
    }
  }
  bindButtons(iframeDocument) {
    window.chooseElement=(row,store)=>{
      this.props.onChange(row.id);
      this.props.hidePopup();
    };
    iframeDocument.addEventListener("click",(e)=>{
      console.log('e.target.parentElement.className',e.target.parentElement);
      if(e.target.parentElement.className.indexOf("takeButton")>-1) {
        e.preventDefault();
        this.props.onChange(e.target.parentElement.dataset.id);
        this.props.hidePopup();
      }
    });
  }
  componentDidMount() {
    if(this._iframe) {
      this._iframe.addEventListener("load",()=>{
        const iframeDocument = this._iframe.contentDocument || this._iframe.contentWindow.document;
        const iframeWindow = this._iframe.contentWindow;
        this.bindButtons(iframeDocument);
        console.log("iframe loaded",iframeDocument);
      });
    }
  }
  renderPopup() {
    return (
      <Popup disablePaddings={true} disableScroll={true} showed={true} onHide={()=>{ this.props.hidePopup(); }}>
        <div className="evaMainWrap" style={{width:'calc(100vw - 40px)',height:'90vh'}}>
          <div className="up12 splice h100">
            {this.props.tree_config || this.props.category?(
              <div className="cell innerMenuPlace s-2 bg-w3 h100">
                <SectionsTree disable_controlls={true} initial={{ category: this.props.category, title:" ",
                  communicatorRef:(communicator)=>{
                    this._sectionsCommunicator=communicator;
                    communicator.subscribe((message)=>{
                      if(message.type == "output") {
                        if(message.command == "section_selected") {
                          const flt={
                            section:message.section_id == 'all'?'':message.section_id == 'root'?'0':message.section_id
                          };
                          this._elementsCommunicator.pushMessage({
                            type: "input",
                            command: "set_simple_filter",
                            filter: flt
                          });
                        }
                      }
                      console.log("SectionsTree SUBSCRIBED_MESS", message, message.type, message.command, message.section_id);
                    })
                  }
                , ...this.props.tree_config || {}}} />
              </div>
            ):null}
            <div className="cell s-10 bg-w2 ofa h100">
              <div className="hpadd20">
                <DynamicTable
                  communicatorRef={(communicator)=>{
                    this._elementsCommunicator=communicator;
                    communicator.subscribe((mess)=>{
                      if(mess.type == "output" && mess.command == "filter_changed" ) {
                        if (mess.data.blocks) {
                          for (var i in mess.data.blocks) {
                            if (mess.data.blocks[i].code === 'section' &&
                              mess.data.blocks[i].compare === '=' &&
                              mess.data.blocks[i].value
                            ) {
                              console.log('mess.data.blocks[i][2]', mess.data.blocks[i][2]);
                              this._sectionsCommunicator.pushMessage({
                                type: 'input',
                                command: 'section_selected',
                                section_id: mess.data.blocks[i].value
                              });
                              break;
                            }

                          }
                        }
                      }

                      console.log("DynamicTable SUBSCRIBED_MESS", mess, mess.type, mess.command, mess.section_id);
                    })
                  }}
                  actionsHandler={(actionType, rowOrStore, store)=>{
                  if(actionType === "chooseElement") {
                    this.props.onChange(rowOrStore.id);
                    this.props.hidePopup();
                  }
                }} local_memory={true} use_local_saver={true} config_route={this.props.select_config || `/sysapi/dynamic/${this.props.category}/dynamicTableChooseConfig`} />
              </div>
            </div>
          </div>
        </div>
      </Popup>
    )
  }
  /*
  <iframe className="db" ref={(ref)=>{ this._iframe=ref; }} style={{width:'90vw',height:'90vh'}} src={`/eva2/index.php?operation=category&action=view&category_id=${this.props.category}&marker_postfix=_shop&mode=iframe`} frameBorder="0"></iframe>
  */
  render() {
    return this.renderPopup();
  }
}



export default ElementSelector;